<template>
    <div class="control-group max-width"
      :class="{
        'invalid': input_invalids && (input_invalids[input_date_start_name] || input_invalids[input_date_end_name])
      }">
        <div class="control" :class="{'required': input_required}">
            <label :for="input_date_start_id">
                {{ Language.say(label_text) }}
            </label>
            <span class="column-group">
                <input
                    :id="input_date_start_id"
                    type="date"
                    class="column-50"
                    :value="input_date_start"
                    @input="onInputDateStart"
                    @change="onChangeDateStart">
                <small>{{Language.say(label_date_conjunction)}}</small>
                <input
                    :id="input_date_end_id"
                    type="date"
                    class="column-50"
                    :value="input_date_end"
                    @input="onInputDateEnd"
                    @change="onChangeDateEnd">
            </span>
        </div>
        <p class="error"
          v-if="input_invalids && (input_invalids[input_date_start_name] || input_invalids[input_date_end_name])">
          {{ Language.say(error_text) }}
        </p>
    </div>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue';
  import Language from '@/js/Shared/Language/Language';

  const props = defineProps({
    input_date_start_id: {
      type: String,
      default: 'sDate1',
    },
    input_date_start_name: {
      type: String,
      required: true,
    },
    input_date_end_id: {
      type: String,
      default: 'sDate2',
    },
    input_date_end_name: {
      type: String,
      required: true,
    },
    input_required: {
      type: Boolean,
      default: false
    },
    input_invalids: {
      type: Object,
      default : () => ({}),
    },
    input_date_start: {
      type: String,
      default: ''
    },
    input_date_end: {
      type: String,
      default: ''
    },
    label_text: {
      type: String,
      default: 'global.forms.label.between_dates'
    },
    label_date_conjunction: {
      type: String,
      default: 'global.forms.label.date_conjunction'
    },
    error_text: {
      type: String,
      default: 'global.forms.invalid.input'
    },
  });

  const emit = defineEmits([
    'change:date_start',
    'update:input_date_start',
    'change:date_end',
    'update:input_date_end',
  ]);

  const onChangeDateStart = ($event) => {
    emit('change:date_start', $event.target.value);
  }

  const onInputDateStart = ($event) => {
    emit('update:input_date_start', $event.target.value);
  }

  const onChangeDateEnd = ($event) => {
    emit('change:date_end', $event.target.value);
  }

  const onInputDateEnd = ($event) => {
    emit('update:input_date_end', $event.target.value);
  }
</script>